<template>
  <layout-basic>
    <v-container class="pa-6" id="billing-sec">
      <v-row>
        <v-col class="Full-Course-Library-Title">
          Company Information
        </v-col>
      </v-row>
      <v-row>
        <v-col md="6" class="pt-4">
          <v-form>
            <v-text-field :error-messages="messages.company_name" v-model="company.company_name" label="Company Name"
              readonly disabled type="text" outlined></v-text-field>
            <v-text-field v-model="company.street" :error-messages="messages.street" label="Street" type="text"
              outlined></v-text-field>
            <v-text-field v-model="company.city" :error-messages="messages.city" label="City" type="text"
              outlined></v-text-field>
            <v-text-field v-model="company.country" :error-messages="messages.country" label="Country" type="text"
              outlined></v-text-field>
            <v-text-field v-model="company.postcode" :error-messages="messages.postcode" label="Postcode" type="text"
              outlined></v-text-field>
            <!-- Theme Color Picker -->
            <v-row align="center" v-if="company.theme_color && company.allow_theme_customization">
                <v-col cols="12" sm="4">
                  <v-text-field v-model="company.theme_color.primary" label="Theme Colour" class=" color-input" hide-details
                    dense outlined readonly>
                    <template v-slot:append>
                      <v-menu v-model="menuButton" :close-on-content-click="false" offset-y transition="scale-transition" max-width="290"
                        min-width="290">
                        <template v-slot:activator="{ on, attrs }">
                          <v-avatar v-bind="attrs" v-on="on" size="24"
                            :style="{ backgroundColor: company.theme_color.primary, cursor: 'pointer', border : '1px solid'}"
                            class="color-circle"></v-avatar>
                        </template>

                        <v-card>
                          <v-color-picker v-model="company.theme_color.primary" hide-mode-switch flat
                            mode="hexa"></v-color-picker>
                        </v-card>
                      </v-menu>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="2">
                  <v-btn v-on="on" outlined small
                      color="secondary" @click="resetToDefaultColor" title="Reset to Default Color">
                      <v-icon small>fa-arrows-rotate</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-btn :style="{ backgroundColor: company.theme_color.primary, color: '#fff' }" elevation="2">
                    Example Button
                  </v-btn>
                </v-col>
              </v-row>
            <!-- Company Logo Upload Component -->
            <CompanyLogoUpload :image.sync="company_logo" class="mt-5" text="Click here to upload Company Logo"
              :type="'company-logo'" :accepted="'image/jpg,image/jpeg,image/png'" :dropzone-id="'company_logo'" />
            <p class="block text-left mt-4 caption">
              Max upload filesize: 1MB<br />
              Recommended Dimensions: 475 × 115<br />
              Accepted formats: PNG, JPG
            </p>
          </v-form>
        </v-col>
      </v-row>
      <v-row class="mb-5">
        <v-col md="6">
          <v-btn style="float:right;" class="btn btn-primary add-course-button text-right" v-if="loading"
            color="primary" loading></v-btn>
          <v-btn v-else class="btn btn-primary add-course-button text-right" color="primary" @click="updateCompany"
            outlined style="float:right;" :disabled="s3Uploading">{{ s3Uploading ? 'Uploading logo…' : 'Save' }}</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>

<script>
import LayoutBasic from "@/layouts/Dashboard";
import companyAPI from "@/api/company.js";
import CompanyLogoUpload from "@/components/global/CompanyLogoUpload";

export default {
  name: "Profile",
  components: {
    LayoutBasic,
    CompanyLogoUpload,
  },
  data() {
    return {
      company: [],
      params: "",
      messages: {},
      successMessage: "Company Information Successfully Updated.",
      errorMessage:
        "Oops, something went wrong! Please check information is correct.",
      waitMessage: "Please wait, we are uploading your image.",
      loading: false,
      valid: true,
      type: "company-logo",
      accepted: "image/jpg,image/jpeg,image/png",
      menuButton: false,
      menuText: false,
    };
  },
  computed: {
    isPartnerLevel() {
      return this.$store.getters.level === 4;
    },
    company_logo() {
      return this.company && this.company.company_logo
        ? this.company.company_logo.url
        : null;
    },
    s3Uploading() {
      return this.$store.getters.s3Uploading;
    }
  },
  mounted() {
    this.$store.dispatch("setS3Uploading", false);
    this.getProfile();
  },
  methods: {
    getProfile() {
      companyAPI.getCompanyById(this.$store.getters.user.company.data.id,this.params).then(response => {
        this.company = response.data.data;
        if(this.company.company_logo){
         this.$store.dispatch("setS3Url", this.company.company_logo.url);
          this.$store.dispatch("setFileDetails", {
          size: this.company.company_logo.file_size,
          name: this.company.company_logo.original_name,
          type: this.company.company_logo.mime_type
        });
        this.$store.dispatch('setDropzoneLoaded', { id: 'company_logo', value: true });
        }
      });
    },
    updateCompany() {
      this.loading = true;

      if (this.$store.getters.s3Url != '') {
        this.$snotify.info(this.waitMessage);
      }

      companyAPI
      .updateCompany(this.company,this.$store.getters.s3Url,this.$store.getters.fileDetails)
      .then((resp) => {
        this.loading = false;
        this.$snotify.success(this.successMessage);
        this.$store.commit("setCompanyLogo",resp.data.data.company_logo);
        if(resp.data.data.allow_theme_customization)
          this.$store.dispatch('theme/applyUserTheme', resp.data.data.theme_color)
        setTimeout(() => {
                         this.$gf.removeBackdrop();
                    },300);
      })
      .catch(err => {
          this.loading = false;
          this.valid = false;
          this.messages = this.$gf.errorResponse(err);
          // Say what was wrong (a logo the server refused, a name too long)
          // rather than only "something went wrong".
          const errors = err && err.response && err.response.data && err.response.data.errors;
          const first = errors && Object.values(errors)[0];
          this.$snotify.error(Array.isArray(first) && first[0] ? first[0] : this.errorMessage);
          setTimeout(() => {
                         this.$gf.removeBackdrop();
                    },300);
        });
    },
    resetToDefaultColor(){
        this.company.theme_color.primary = process.env.VUE_APP_PRIMARY_COLOR;
    },
  }
};
</script>
